import React, { useEffect } from 'react';
import { loadGoogleMaps } from "./googleMap/loadGoogleMaps";

function convertCoordinates(arrayOfCoordinates) {
    return arrayOfCoordinates.map(({ latitude, longitude }) => ({
      lat: latitude,
      lng: longitude
    }));
} 

const MapComponent = ({startLocation,endLocation,middleLocations, defaultColor, defaultZoom, sx, endLocationIcon}) => {
  const newStartLocation = startLocation ? convertCoordinates(startLocation) : [];
  const newEndLocation = endLocation ? convertCoordinates(endLocation) : [];
  const newMiddleLocations = middleLocations ? 
  middleLocations.map(location => convertCoordinates(location)[0]) : [];

  const Locations = newStartLocation.concat(newMiddleLocations,newEndLocation);

  useEffect(() => {
    const initMap = () => {
      const map = new window.google.maps.Map(document.getElementById("map"), {
        zoom: (defaultZoom || 12),
        center: Locations[0],
      });
      const flightPlanCoordinates = Locations;
      const flightPath = new window.google.maps.Polyline({
        path: flightPlanCoordinates,
        geodesic: true,
        strokeColor: (defaultColor||"#8C3B5E"),
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });
    
      flightPath.setMap(map);
      
      new window.google.maps.Marker({
        position: Locations[0],
        map: map,
        title: "Start Location",
        icon: {
          url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png", 
        }
      });

      new window.google.maps.Marker({
        position: Locations[Locations.length - 1],
        map: map,
        title: "Last Updated Location",
        icon: endLocationIcon || {
          url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png", 
        }
      });
    };

    // shared singleton loader — never inject the Maps SDK more than once per page
    let cancelled = false;
    loadGoogleMaps().then(() => { if (!cancelled) initMap(); }).catch(() => {});
    return () => { cancelled = true; };
  }, [startLocation]);

  return <div id="map" style={sx|| {height: '300px'}}></div>;
};

export default MapComponent;
